import { render, staticRenderFns } from "./SurveyPlanEmailTo.vue?vue&type=template&id=964e9150&scoped=true&"
import script from "./SurveyPlanEmailTo.vue?vue&type=script&lang=ts&"
export * from "./SurveyPlanEmailTo.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyPlanEmailTo.vue?vue&type=style&index=0&id=964e9150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964e9150",
  null
  
)

export default component.exports